import styled from "styled-components";


export const Component = styled.button<{
    type?: "button"
}>``;